export function FleetOrderMonitoringCard({
  alt,
  imageUrl,
  loading = false,
  pageLabel,
}) {
  return (
    <figure className="fleet-monitoring-card-preview">
      <div className="fleet-monitoring-card-preview__frame">
        {loading ? (
          <div className="fleet-monitoring-card-preview__skeleton" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
        ) : imageUrl ? (
          <img alt={alt} src={imageUrl} />
        ) : (
          <div className="fleet-monitoring-card-preview__empty">
            Preview monitoring belum tersedia.
          </div>
        )}
      </div>

      {pageLabel && <figcaption>{pageLabel}</figcaption>}
    </figure>
  );
}
